import { Injectable } from '@angular/core';
import { Observable, Subject, observable, throwError } from 'rxjs';
import { catchError, share } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HelperService } from './helper.service';
import { ActivatedRoute, Params } from '@angular/router';
import { webSocket } from 'rxjs/webSocket';

@Injectable({
  providedIn: 'root'
})
export class WebSocketSourceService {
  private webSocket: WebSocket;
  public readonly webSocketSourceSubject: Subject<MessageEvent>;
// private webSocketSourceSubject: Subject<any>;
  private baseURL: string = environment.python_websocket_source_base_url;
//   public changes = this.onSubject.asObservable().pipe(share());
  constructor(public helperService: HelperService) {
    this.webSocketSourceSubject = new Subject();
  }
  
  public initializeWebSocket(status, payload?, params?): void {
    
    // //console.log(headers, headers["endpoint-url"]);
    if(status == "open"){
    let params=''
    for(let param of Object.keys(payload.params)){
      params+=`${param}=${payload.params[param]}&`
    }
    this.baseURL=environment.python_websocket_source_base_url+'/bizdata_ws'+'?'+params
    this.baseURL=this.baseURL.slice(0,this.baseURL.length-1)
    this.webSocket = new WebSocket(this.baseURL);
    this.webSocket.onopen = ()=>{
        //console.log('WebSocket connection established.');
        let obj ={
          'headers':payload.headers,
          'message':payload.message,
        };
        // this.webSocket.send(JSON.stringify(headers));
        this.sendMessage(JSON.stringify(obj));
    }
    }else if(status == "close"){
        // if(this.webSocket.readyState == 1){        
            //console.log("Web sockect connection close ");
            this.webSocket.close();
        // }
    }     
    this.webSocket.onmessage = (message) => {
      this.webSocketSourceSubject.next(message);
    };
    this.webSocket.onerror = (error) => {
      //console.log("on error connection", error);
      this.webSocketSourceSubject.error(error);
    }
    this.webSocket.onclose = (e) =>{ 
      //console.log("on close connection", e.reason);
      if (e.wasClean) {
          if(e.reason != ""){
              if(e.reason != "keepalive ping timeout"){
                  this.helperService.presentToast("Logs are not available or generated", 3000);                        
              }else{
                  this.helperService.presentToast(e.reason, 3000);                        
              }
          }
      }
      // this.webSocketSourceSubject.complete();
    }
    
  }
  public getMessages(): Observable<MessageEvent> {
    return this.webSocketSourceSubject.asObservable()
      .pipe(//delay(1000),
        share(),
        catchError(err => this.handleError(err))
      );
  }

  private handleError(error: Error): Observable<never> {
    // Notify user, attempt reconnection, etc.
    //console.log(error);
    return throwError(error);
  }

   waitForOpenConnection = (socket) => {
    return new Promise<void>((resolve, reject) => {
        const maxNumberOfAttempts = 10
        const intervalTime = 200 //ms

        let currentAttempt = 0
        const interval = setInterval(() => {
            if (currentAttempt > maxNumberOfAttempts - 1) {
                clearInterval(interval)
                reject(new Error('Maximum number of attempts exceeded'))
            } else if (socket.readyState === socket.OPEN) {
                clearInterval(interval)
                resolve()
            }
            currentAttempt++
        }, intervalTime)
    })
}

 sendMessage = async (msg) => {
    if (this.webSocket.readyState !== this.webSocket.OPEN) {
        try {
            await this.waitForOpenConnection(this.webSocket)
            this.webSocket.send(msg)
        } catch (err) { console.error(err) }
    } else {
        this.webSocket.send(msg)
    }
}
}